import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck, X } from "lucide-react";
import { api } from "@/lib/api";

export const PromoBanner = () => {
  const [banner, setBanner] = useState(null);
  const [closed, setClosed] = useState(() => sessionStorage.getItem("ds_banner_closed") === "1");

  useEffect(() => {
    api.get("/banner").then((r) => setBanner(r.data)).catch(() => {});
  }, []);

  if (!banner?.enabled || !banner.text || closed) return null;

  const close = () => {
    sessionStorage.setItem("ds_banner_closed", "1");
    setClosed(true);
  };

  return (
    <div className="relative bg-gold text-slate-900" data-testid="promo-banner">
      <Link
        to={banner.link || "/catalogue"}
        className="flex items-center justify-center gap-2 px-10 py-2 text-center text-xs font-semibold transition-opacity hover:opacity-80 sm:text-sm"
        data-testid="promo-banner-link"
      >
        <Truck className="h-4 w-4 shrink-0" />
        <span>{banner.text}</span>
      </Link>
      <button
        type="button"
        onClick={close}
        aria-label="Fermer le bandeau"
        className="absolute right-2 top-1/2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-full hover:bg-black/10"
        data-testid="promo-banner-close"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
